const normalize = value => {
    if (Array.isArray(value)) return value.map(normalize)
    if (value && typeof value === "object") {
        return Object.keys(value).sort().reduce((result, key) => {
            result[key] = normalize(value[key])
            return result
        }, {})
    }
    return value ?? null
}

export const createAgentDraftFingerprint = value => JSON.stringify(normalize(value))

export const hasAgentDraftChanges = ({ form, initialForm, fixedResponses, initialFixedResponses }) => (
    createAgentDraftFingerprint(form) !== initialForm
    || (initialFixedResponses !== null && createAgentDraftFingerprint(fixedResponses) !== initialFixedResponses)
)
